import {get} from "lodash"
import BaseService from "./Base"
import {
    DeleteHighschoolsPayload,
    EditHighschoolPayload,
    HighschoolCreatePayload,
    ListHighschoolsPayload
} from "types/highschools"

class HighschoolsService extends BaseService {
    getAllHighschools = async (params: ListHighschoolsPayload) => {
        const response = await this.post("/v1/highschools/list", params)
        return get(response, "data", [])
    }

    createHighschool = async (params: HighschoolCreatePayload) => {
        const response = await this.post("/v1/highschools/create", params)
        return get(response, "data.data", {})
    }

    editHighschool = async (id: number, params: EditHighschoolPayload) => {
        const response = await this.post("/v1/highschools/edit", {...params, id})
        return get(response, "data.data", {})
    }

    deleteHighschool = async (params: DeleteHighschoolsPayload) => {
        const response = await this.post("/v1/highschools/delete", params)
        return get(response, "data.data", {})
    }
}

export default HighschoolsService
